// extracted by mini-css-extract-plugin
export default {"banner-card":"banner-card-3165","banner-images":"banner-images-f30b","image":"image-af60","map-image":"map-image-8043"};